import React from 'react';
import styles from './HeaderWrapper.module.scss';

export const HeaderWrapper = ({ title, children }) => {
  return (
    <div className={styles.header}>
      <h1 className={styles.header__title}>{title}</h1>

      {children}
    </div>
  );
};
